// src/services/ItemServices.js
import { apiService } from './apiService';

export function getItemService(data) {
  return apiService({
    method: 'POST',
    url: '/item/data',
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function getByIdItemService(id) {
  return apiService({
    method: 'GET',
    url: '/item/' + id,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function addItemService(data) {
  return apiService({
    method: 'POST',
    url: '/item',
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function updateItemService(id, data) {
  return apiService({
    method: 'PUT',
    url: '/item/' + id,
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function updateItemImageService(id, data) {
  return apiService({
    method: 'PUT',
    url: '/item/image/' + id,
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function deleteItemService(id) {
  return apiService({
    method: 'DELETE',
    url: '/item/' + id,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function getTableItemService(data) {
  return apiService({
    method: 'GET',
    url: '/front/item/data',
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

/* ────────────────────────────────────────── *
 *           NEW: Perishable Listings         *
 * ────────────────────────────────────────── */

// Items for POS (only perishable)
export function getPosItemService(data) {
  return apiService({
    method: 'POST',
    url: '/item/pos-data',
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

// Items for Dining (alias of POS; same perishable filter)
export function getDiningItemService(data) {
  return apiService({
    method: 'POST',
    url: '/item/pos-data',
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}
